import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {RootState} from 'modules';
import {setStatusCutAction} from 'modules/cut';
import {IVodInfoData} from 'lib/api/vodInfo';
import {setClickLog} from 'lib/utils';
import EditMode from 'components/edit/EditMode';
import useEditWarn from 'hooks/useEditWarn';

/**
 * 편집모드(좌측 UI) 컨테이너
 */

const EditModeContainer = () => {
  const dispatch = useDispatch();
  const {
    vodData,
    playingTime,
    cut,
    ui: {editMode},
    timeline: {sectionIdx},
  } = useSelector(({vodInfo, video, cut, ui, timeline}: RootState) => ({
    vodData: vodInfo.titleFileInfo.data,
    playingTime: video.playingTime,
    cut,
    ui,
    timeline,
  }));
  const [_, setTime] = useState('');
  const displayEditWarn = useEditWarn(
    editMode,
    sectionIdx,
    cut.sectionNode,
    cut.lists,
  ); // 구간 선택 안내 문구 표시

  // 현재 재생시간 업데이트
  const onChangeTime = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTime(e.target.value);
  };
  // 모드 선택 클릭 함수
  const onClickMode = () => {
    // 컷 편집 모드 실행
    if (!cut.status) {
      dispatch(setStatusCutAction(true));

      if (!vodData) return;
      const {response} = vodData as IVodInfoData;
      if (!response.info) return;

      const {title_no} = response.info;
      let clickLogParam = `button_type=cut_on&title_no=${title_no}`;

      if (editMode !== 'section') {
        clickLogParam += `&editor_type=${editMode}_editor`;
      }
      setClickLog(clickLogParam); // 클릭 로그
    } else {
      // 컷 편집 모드 종료
      dispatch(setStatusCutAction(false));

      if (!vodData) return;
      const {response} = vodData as IVodInfoData;
      if (!response.info) return;

      const {title_no} = response.info;
      let clickLogParam = `button_type=cut_off&title_no=${title_no}`;

      if (editMode !== 'section') {
        clickLogParam += `&editor_type=${editMode}_editor`;
      }
      setClickLog(clickLogParam); // 클릭 로그
    }
  };

  return (
    <EditMode
      time={playingTime}
      cut={cut}
      displayEditWarn={displayEditWarn}
      onChangeTime={onChangeTime}
      onClickMode={onClickMode}
    />
  );
};

export default EditModeContainer;
